<p-card>
    <div style="text-align: center;">
        <p-progressSpinner *ngIf="loading" [style]="{width: '200px', height: '200px'}"></p-progressSpinner>
    </div>
    <div class="card" *ngIf="!loading">
        <div>
            <span style="
            font-size: 30px;
            background-color: #969696;
            border-radius: 20px;
            margin-left: 45px;
            padding: 10px;
        ">Total Chamados não Atendidos: {{AtendeNAO}}</span>
        </div>
    <p-carousel [value]="products" styleClass="custom-carousel" [numVisible]="3" [numScroll]="1" [circular]="true" [autoplayInterval]="3000" [responsiveOptions]="responsiveOptions">
        <ng-template pTemplate="header">
            <h5></h5>
        </ng-template>
        <ng-template let-product pTemplate="item">
            <!-- <div class="product-item" style="background-color: rgb(219, 235, 219);margin: 5px; border-radius: 10px;"> -->
                <div class="product-item" [style.background-color]="product.Color" [ngStyle]="{'margin':'5px;','border-radius':'10px', 'height':'600px'}">
                    <div class="product-item-content" style="margin: 5px;">
                    <!-- <div class="p-mb-3">
                        <img src="assets/showcase/images/demo/product/{{product.image}}" [alt]="product.name" class="product-image" />
                    </div> -->
                    <div class="p-grid p-fluid">

                        <div class="p-col-12 p-md-6 p-lg-4">
                            <h4 class="p-mb-1"><b>Data: </b></h4>{{product.data | date: 'dd/MM/yyyy'}}
                        </div>
                        <div class="p-col-12 p-md-6 p-lg-2">
                            <h4 class="p-mb-1"><b>Hora: </b></h4>{{product.hora}}
                        </div>
                    </div>
                    <div>
                        <h4 class="p-mb-1"><b>Cliente: </b></h4>{{product.cliente}}
                        <h4 class="p-mb-1"><b>Endereço: </b></h4>{{product.endereco}}
                        <h4 class="p-mb-1"><b>Reclamante: </b></h4>{{product.reclamante}}
                        <h4 class="p-mb-1"><b>Elevador: </b></h4>{{product.elevador}}
                        <h4 class="p-mb-1"><b>Defeito: </b></h4>{{product.defeito}}                
                        <h4 class="p-mb-1"><b>Técnico: </b></h4>{{product.mec}}
                    </div>
                </div>
            </div>
        </ng-template>
    </p-carousel>
</div>

</p-card>
